"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3354],{

/***/ 43437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BY": function() { return /* binding */ LP_HOLDERS_FEE; },
/* harmony export */   "Bq": function() { return /* binding */ ONE_DAY_UNIX; },
/* harmony export */   "DY": function() { return /* binding */ PCS_ETH_START; },
/* harmony export */   "MV": function() { return /* binding */ WEEKS_IN_YEAR; },
/* harmony export */   "OZ": function() { return /* binding */ MINIMUM_SEARCH_CHARACTERS; },
/* harmony export */   "Rr": function() { return /* binding */ PCS_V2_START; },
/* harmony export */   "Tb": function() { return /* binding */ ONE_HOUR_SECONDS; },
/* harmony export */   "Vd": function() { return /* binding */ ETH_TOKEN_BLACKLIST; },
/* harmony export */   "hT": function() { return /* binding */ TREASURY_FEE; },
/* harmony export */   "om": function() { return /* binding */ TOTAL_FEE; },
/* harmony export */   "si": function() { return /* binding */ ITEMS_PER_INFO_TABLE_PAGE; },
/* harmony export */   "tE": function() { return /* binding */ TOKEN_BLACKLIST; },
/* harmony export */   "xy": function() { return /* binding */ BUYBACK_FEE; }
/* harmony export */ });
var MINIMUM_SEARCH_CHARACTERS = 2;
var WEEKS_IN_YEAR = 52.1429;
var TOTAL_FEE = 0.0025;
var LP_HOLDERS_FEE = 0.0017;
var TREASURY_FEE = 0.000225;
var BUYBACK_FEE = 0.000575;
var PCS_V2_START = 1619136000 // April 23, 2021, 12:00:00 AM
;
var PCS_ETH_START = 1664130827 // Sep 23, 2022, 02:33:47 AM
;
var ONE_DAY_UNIX = 86400 // 24h * 60m * 60s
;
var ONE_HOUR_SECONDS = 3600;
var ITEMS_PER_INFO_TABLE_PAGE = 10;
// These tokens are either incorrectly priced or have some other issues that spoil the query data
// None of them present any interest as they have almost 0 daily trade volume
var TOKEN_BLACKLIST = [
    // These ones are copied from v1 info
    "0x495c7f3a713870f68f8b418b355c085dfdc412c3",
    "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
    "0xe31debd7abff90b06bca21010dd860d8701fd901",
    "0xfc989fbb6b3024de5ca0144dc23c18a063942ac1",
    "0xe40fc6ff5f2895b44268fd2e1a421e07f567e007",
    "0xfd158609228b43aa380140b46fff3cdf9ad315de",
    "0xc00af6212fcf0e6fd3143e692ccd4191dc308bea",
    "0x205969b3ad459f7eba0dee07231a6357183d3fb6",
    "0x0bd67d358636fd7b0597724aa4f20beedbf3073a",
    "0xedf5d2a561e8a3cb5a846fbce24d2ccd88f50075",
    "0x702b0789a3d4dade1688a0c8b7d944e5ba80fc30",
    "0x041929a760d7049edaef0db246fa76ec975e90cc",
    "0xba098df8c6409669f5e6ec971ac02cd5982ac108",
    "0x1bbed115afe9e8d6e9255f18ef10d43ce6608d94",
    "0xe99512305bf42745fae78003428dcaf662afb35d",
    "0xbE609EAcbFca10F6E5504D39E3B113F808389056",
    "0x847daf9dfdc22d5c61c4a857ec8733ef5950e82e",
    "0xdbf8913dfe14536c0dae5dd06805afb2731f7e7b",
    // These ones are newly found
    "0xF1D50dB2C40b63D2c598e2A808d1871a40b1E653",
    "0x4269e4090ff9dfc99d8846eb0d42e67f01c3ac8b", 
];
var ETH_TOKEN_BLACKLIST = [
    "0x72b169ad8af6c4fb53056b6a2a85602ad6863864"
];


/***/ }),

/***/ 79467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dw": function() { return /* binding */ multiChainPaths; },
/* harmony export */   "Ho": function() { return /* binding */ multiChainQueryEndPoint; },
/* harmony export */   "J5": function() { return /* binding */ checkIsStableSwap; },
/* harmony export */   "OO": function() { return /* binding */ multiChainBlocksClient; },
/* harmony export */   "Pi": function() { return /* binding */ multiChainId; },
/* harmony export */   "WR": function() { return /* binding */ multiChainQueryMainToken; },
/* harmony export */   "YM": function() { return /* binding */ multiChainStartTime; },
/* harmony export */   "nA": function() { return /* binding */ multiChainScan; },
/* harmony export */   "rf": function() { return /* binding */ getMultiChainQueryEndPointWithStableSwap; },
/* harmony export */   "z2": function() { return /* binding */ multiChainTokenBlackList; }
/* harmony export */ });
/* unused harmony export multiChainQueryClient */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47842);
/* harmony import */ var utils_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25997);
/* harmony import */ var config_constants_endpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10494);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90902);
/* harmony import */ var config_constants_info__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43437);





var multiChainQueryMainToken = {
    BSC: "BNB",
    ETH: "ETH"
};
var multiChainBlocksClient = {
    BSC: config_constants_endpoints__WEBPACK_IMPORTED_MODULE_1__/* .BLOCKS_CLIENT */ .I0,
    ETH: config_constants_endpoints__WEBPACK_IMPORTED_MODULE_1__/* .BLOCKS_CLIENT_ETH */ .Hs
};
var multiChainStartTime = {
    BSC: config_constants_info__WEBPACK_IMPORTED_MODULE_3__/* .PCS_V2_START */ .Rr,
    ETH: config_constants_info__WEBPACK_IMPORTED_MODULE_3__/* .PCS_ETH_START */ .DY
};
var multiChainId = {
    BSC: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.BSC */ .a_.BSC,
    ETH: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.ETHEREUM */ .a_.ETHEREUM
};
var _obj;
var multiChainPaths = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.BSC */ .a_.BSC, ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.ETHEREUM */ .a_.ETHEREUM, "/eth"), _obj);
var multiChainQueryClient = {
    BSC: utils_graphql__WEBPACK_IMPORTED_MODULE_0__/* .infoClient */ .dQ,
    ETH: utils_graphql__WEBPACK_IMPORTED_MODULE_0__/* .infoClientETH */ .GJ
};
var multiChainQueryEndPoint = {
    BSC: config_constants_endpoints__WEBPACK_IMPORTED_MODULE_1__/* .INFO_CLIENT */ .JY,
    ETH: config_constants_endpoints__WEBPACK_IMPORTED_MODULE_1__/* .INFO_CLIENT_ETH */ .EC
};
var multiChainScan = {
    BSC: "BscScan",
    ETH: "EtherScan"
};
var multiChainTokenBlackList = {
    BSC: config_constants_info__WEBPACK_IMPORTED_MODULE_3__/* .TOKEN_BLACKLIST */ .tE,
    ETH: config_constants_info__WEBPACK_IMPORTED_MODULE_3__/* .ETH_TOKEN_BLACKLIST */ .Vd
};
var getMultiChainQueryEndPointWithStableSwap = function(chainName) {
    var isStableSwap = checkIsStableSwap();
    if (isStableSwap) return utils_graphql__WEBPACK_IMPORTED_MODULE_0__/* .infoStableSwapClient */ .MS;
    return multiChainQueryClient[chainName];
};
var checkIsStableSwap = function() {
    return window.location.href.includes("stableSwap");
};


/***/ }),

/***/ 84785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ formatAmount; }
/* harmony export */ });
/* unused harmony export getFirstThreeNonZeroDecimals */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1246);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);

// Returns first 2 digits after first non-zero decimal
// i.e. 0.001286 -> 0.0012, 0.9845 -> 0.98, 0.0102 -> 0.010, etc
// Intended to be used for tokens whose value is less than $1
// https://stackoverflow.com/a/23887837
var getFirstThreeNonZeroDecimals = function(value) {
    return value.toFixed(9).match(/^-?\d*\.?0*\d{0,2}/)[0];
};
/**
 * This function is used to format token prices, liquidity, amount of tokens in TX, and in general any numbers on info section
 * @param amount - amount to be formatted
 * @param notation - whether to show 1M or 1,000,000
 * @param displayThreshold - threshold below which it will return simply <displayThreshold instead of actual value, e.g. if 0.001 -> returns <0.001 for 0.0005
 * @param tokenPrecision - set to true when you want precision to be 3 decimals for values < 1 and 2 decimals for values > 1
 * @param isInteger - if true the values will contain decimal part only if the amount is > 1000
 * @returns formatted string ready to be displayed
 */ var formatAmount = function(amount, options) {
    var ref = options || {
        notation: amount >= 10000 ? "compact" : "standard"
    }, _notation = ref.notation, notation = _notation === void 0 ? amount >= 10000 ? "compact" : "standard" : _notation, displayThreshold = ref.displayThreshold, tokenPrecision = ref.tokenPrecision, isInteger = ref.isInteger;
    if (amount === 0) {
        if (isInteger) {
            return "0";
        }
        return "0.00";
    }
    if (!amount) return "-";
    if (displayThreshold && amount < displayThreshold) {
        return "<".concat(displayThreshold);
    }
    if (amount < 1 && !tokenPrecision) {
        return getFirstThreeNonZeroDecimals(amount);
    }
    var precision = 2;
    if (tokenPrecision) {
        precision = amount < 1 ? 3 : 2;
    }
    var format = "0.".concat("0".repeat(precision), "a");
    if (notation === "standard") {
        format = "0,0.".concat("0".repeat(precision));
    }
    if (isInteger && amount < 1000) {
        format = "0";
    }
    var amountWithPrecision = parseFloat(amount.toFixed(precision));
    // toUpperCase is needed cause numeral doesn't have support for capital K M B out of the box
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(amountWithPrecision).format(format).toUpperCase();
};


/***/ }),

/***/ 33992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getBlocksFromTimestamps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5163);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6647);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34498);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var state_info_constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79467);
/* harmony import */ var _views_Info_utils_infoQueryHelpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56615);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "query blocks {\n    ",
        "\n  }"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getBlockSubqueries = function(timestamps) {
    return timestamps.map(function(timestamp) {
        return "t".concat(timestamp, ":blocks(first: 1, orderBy: timestamp, orderDirection: desc, where: { timestamp_gt: ").concat(timestamp, ", timestamp_lt: ").concat(timestamp + 600, " }) {\n      number\n    }");
    });
};
var blocksQueryConstructor = function(subqueries) {
    return (0,graphql_request__WEBPACK_IMPORTED_MODULE_1__.gql)(_templateObject(), subqueries);
};
/**
 * @notice Fetches block objects for an array of timestamps.
 * @param {Array} timestamps
 */ var getBlocksFromTimestamps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(timestamps) {
        var sortDirection, skipCount, chainName, fetchedData, blocks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sortDirection = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "desc", skipCount = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 500, chainName = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : "BSC";
                    if ((timestamps === null || timestamps === void 0 ? void 0 : timestamps.length) === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        (0,_views_Info_utils_infoQueryHelpers__WEBPACK_IMPORTED_MODULE_4__/* .multiQuery */ .L)(blocksQueryConstructor, getBlockSubqueries(timestamps), state_info_constant__WEBPACK_IMPORTED_MODULE_3__/* .multiChainBlocksClient */ .OO[chainName], skipCount)
                    ];
                case 1:
                    fetchedData = _state.sent();
                    blocks = [];
                    if (fetchedData) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // eslint-disable-next-line no-restricted-syntax
                            for(_iterator = Object.keys(fetchedData)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                key = _step.value;
                                if (fetchedData[key].length > 0) {
                                    blocks.push({
                                        timestamp: key.split("t")[1],
                                        number: parseInt(fetchedData[key][0].number, 10)
                                    });
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // graphql-request does not guarantee same ordering of batched requests subqueries, hence manual sorting
                        return [
                            2,
                            lodash_orderBy__WEBPACK_IMPORTED_MODULE_2___default()(blocks, function(block) {
                                return block.number;
                            }, sortDirection)
                        ];
                    }
                    return [
                        2,
                        blocks
                    ];
            }
        });
    });
    return function getBlocksFromTimestamps(timestamps) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 3063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _ethersproject_address__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58194);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30733);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_memoize__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7599);



var getTokenLogoURL = lodash_memoize__WEBPACK_IMPORTED_MODULE_0___default()(function(token) {
    if (token) {
        return "".concat(config__WEBPACK_IMPORTED_MODULE_1__/* .BASE_S3 */ .Q_, "/images/tokens/").concat((0,_ethersproject_address__WEBPACK_IMPORTED_MODULE_2__.getAddress)(token.address), ".png");
    }
    return null;
}, function(t) {
    return "".concat(t.chainId, "#").concat(t.address);
});
/* harmony default export */ __webpack_exports__["Z"] = (getTokenLogoURL);


/***/ }),

/***/ 25997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GJ": function() { return /* binding */ infoClientETH; },
/* harmony export */   "MS": function() { return /* binding */ infoStableSwapClient; },
/* harmony export */   "dQ": function() { return /* binding */ infoClient; },
/* harmony export */   "vA": function() { return /* binding */ getGQLHeaders; }
/* harmony export */ });
/* unused harmony exports infoClientWithChain, infoServerClient, stableSwapClient, bitQueryServerClient */
/* harmony import */ var config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10494);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6647);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_1__);
/* provided dependency */ var process = __webpack_require__(34406);



// Extra headers
// Mostly for dev environment
// No production env check since production preview might also need them
var getGQLHeaders = function(endpoint) {
    if (endpoint === config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY) {
        return {
            "X-Sf": process.env.NEXT_PUBLIC_SF_HEADER || // hack for inject CI secret on window
             true && // @ts-ignore
            window.sfHeader
        };
    }
    return undefined;
};
var infoClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY, {
    headers: getGQLHeaders(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY)
});
var infoClientWithChain = function(chainId) {
    return new GraphQLClient(INFO_CLIENT_WITH_CHAIN[chainId], {
        headers: getGQLHeaders(INFO_CLIENT_WITH_CHAIN[chainId])
    });
};
var infoClientETH = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT_ETH */ .EC);
var infoStableSwapClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .STABLESWAP_SUBGRAPH_CLIENT */ .gr);
var infoServerClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY, {
    headers: {
        "X-Sf": process.env.SF_HEADER
    },
    timeout: 5000
});
var stableSwapClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .STABLESWAP_SUBGRAPH_CLIENT */ .gr, {
    headers: getGQLHeaders(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .STABLESWAP_SUBGRAPH_CLIENT */ .gr)
});
var bitQueryServerClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .BIT_QUERY */ .d$, {
    headers: {
        // only server, no `NEXT_PUBLIC` not going to expose in client
        "X-API-KEY": process.env.BIT_QUERY_HEADER
    },
    timeout: 5000
});


/***/ }),

/***/ 10549:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var requestWithTimeout = function(graphQLClient, request, variables) {
    var timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30000;
    return Promise.race([
        variables ? graphQLClient.request(request, variables) : graphQLClient.request(request),
        new Promise(function(_, reject) {
            setTimeout(function() {
                reject(new Error("Request timed out after ".concat(timeout, " milliseconds")));
            }, timeout);
        }), 
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (requestWithTimeout);


/***/ }),

/***/ 56615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ multiQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5163);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6647);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25997);
/* harmony import */ var utils_requestWithTimeout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10549);






/**
 * Helper function to get large amount GraphQL subqueries
 * @param queryConstructor constructor function that combines subqueries
 * @param subqueries individual queries
 * @param endpoint GraphQL endpoint
 * @param skipCount how many subqueries to fire at a time
 * @returns
 */ var multiQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(queryConstructor, subqueries, endpoint) {
        var skipCount, fetchedData, allFound, skip, client, end, subqueriesSlice, result, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    skipCount = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 1000;
                    fetchedData = {};
                    allFound = false;
                    skip = 0;
                    client = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient(endpoint, {
                        headers: (0,utils_graphql__WEBPACK_IMPORTED_MODULE_1__/* .getGQLHeaders */ .vA)(endpoint)
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!!allFound) return [
                        3,
                        3
                    ];
                    end = subqueries.length;
                    if (skip + skipCount < subqueries.length) {
                        end = skip + skipCount;
                    }
                    subqueriesSlice = subqueries.slice(skip, end);
                    return [
                        4,
                        (0,utils_requestWithTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(client, queryConstructor(subqueriesSlice))
                    ];
                case 2:
                    result = _state.sent();
                    fetchedData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, fetchedData, result);
                    allFound = Object.keys(result).length < skipCount || skip + skipCount > subqueries.length;
                    skip += skipCount;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        fetchedData
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetch info data", error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function multiQuery(queryConstructor, subqueries, endpoint) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 8659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(13670);
;// CONCATENATED MODULE: ../../packages/uikit/src/components/Card/StyledCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  ",
        "\n\n  padding: 1px 1px 3px 1px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return theme.colors.cardBorder;
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eecfaa46-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-eecfaa46-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var theme = param.theme, background = param.background;
    return background !== null && background !== void 0 ? background : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ../../packages/uikit/src/components/Card/Card.tsx






var Card = function(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 13023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19453);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66803);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 10px;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  display: block;\n  font-size: 16px;\n  height: ",
        ";\n  outline: 0;\n  padding: 0 16px;\n  width: 100%;\n  border: 1px solid ",
        ";\n\n  &::placeholder {\n    color: ",
        ";\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    box-shadow: none;\n    color: ",
        ";\n    cursor: not-allowed;\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Priority: Warning --> Success
 */ var getBoxShadow = function(param) {
    var _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? false : _isSuccess, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, theme = param.theme;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.inset;
};
var getHeight = function(param) {
    var _scale = param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD : _scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.LG */ .Q.LG:
            return "48px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "40px";
    }
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-955df6e8-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, getBoxShadow, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, getHeight, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme, isWarning = param.isWarning, isSuccess = param.isSuccess;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.focus;
});
Input.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    isSuccess: false,
    isWarning: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 66803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};


/***/ })

}]);